import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { ContactDetailsFormNewModel } from './formModel';
import { getEnumValues } from '../../../services/common/miscUtils';
import Yup, { maxMobileNumberLength, minMobileNumberLength, regExEmail } from '../../../services/common/validation';
import { CorrespondenceMethodEnum, TitleEnum } from '../../../types/forms';

export const contactDetailsFormSchema = (): ObjectSchema<ContactDetailsFormNewModel> => {
  return Yup.object({
    title: Yup.string().required(t('validation:required')).oneOf(getEnumValues(TitleEnum)),
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    dateOfBirth: Yup.string().required(t('validation:required')),
    email: Yup.string().required(t('validation:required')).matches(regExEmail, t('validation:invalidEmail')),
    invoiceEmailAddress: Yup.string().notRequired().matches(regExEmail, t('validation:invalidEmail')),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    mobileNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    correspondenceMethod: Yup.string().requiredWithMsg().oneOf(getEnumValues(CorrespondenceMethodEnum)),
  });
};
